var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperHappyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 444,
    viewBox: "0 0 444 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444 222C444 344.607 344.607 444 222 444C99.3928 444 0 344.607 0 222C0 99.3928 99.3928 0 222 0C344.607 0 444 99.3928 444 222ZM330.292 170.434C330.292 188.16 315.922 202.53 298.195 202.53C280.469 202.53 266.099 188.16 266.099 170.434C266.099 152.707 280.469 138.337 298.195 138.337C315.922 138.337 330.292 152.707 330.292 170.434ZM138.665 203.53C156.392 203.53 170.762 189.16 170.762 171.434C170.762 153.707 156.392 139.337 138.665 139.337C120.939 139.337 106.569 153.707 106.569 171.434C106.569 189.16 120.939 203.53 138.665 203.53ZM220.93 372.704C155.264 370.783 127.233 359.099 102.138 282.34C100.829 278.339 104.012 274.314 108.211 274.607L221.197 282.481L334.184 274.607C338.383 274.314 341.566 278.339 340.257 282.34C315.162 359.099 287.131 370.783 221.465 372.704V372.72C221.376 372.717 221.286 372.715 221.197 372.712C221.108 372.715 221.019 372.717 220.93 372.72V372.704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperHappyFace);
export default __webpack_public_path__ + "static/media/super-happy-face.e7ad0389785290b9faf970e0c3c62fc5.svg";
export { ForwardRef as ReactComponent };